var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg131(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.5,
    height: 48.291,
    viewBox: "0 0 48.5 48.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_991_",
    transform: "translate(0.25 -1.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_317_",
    transform: "translate(0 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_670_",
    d: "M43.125,12.844H28.688a4.755,4.755,0,0,0-.712-1.713l8.03-8.03a.938.938,0,1,0-1.326-1.326L26.651,9.8a4.77,4.77,0,0,0-5.3,0L16.788,5.243a.938.938,0,1,0-1.326,1.326l4.561,4.561a4.755,4.755,0,0,0-.712,1.713H4.875A4.881,4.881,0,0,0,0,17.719V44.344a4.881,4.881,0,0,0,4.875,4.875h38.25A4.881,4.881,0,0,0,48,44.344V17.719A4.881,4.881,0,0,0,43.125,12.844ZM24,10.875a2.911,2.911,0,0,1,2.75,1.969h-5.5A2.911,2.911,0,0,1,24,10.875ZM46.125,44.344a3,3,0,0,1-3,3H4.875a3,3,0,0,1-3-3V17.719a3,3,0,0,1,3-3h38.25a3,3,0,0,1,3,3Z",
    transform: "translate(0 -1.5)",
    fill: "#f24462",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_684_",
    d: "M78.563,170.5H67.875a.938.938,0,0,0,0,1.875h9.75V196H49.875V172.375h9.563a.938.938,0,0,0,0-1.875h-10.5a.938.938,0,0,0-.937.938v25.5a.938.938,0,0,0,.937.938H78.563a.938.938,0,0,0,.938-.937v-25.5A.938.938,0,0,0,78.563,170.5Z",
    transform: "translate(-43.5 -154.656)",
    fill: "#f24462",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_697_",
    d: "M409,310.5a3,3,0,1,0,3,3A3,3,0,0,0,409,310.5Zm0,4.125a1.125,1.125,0,1,1,1.125-1.125A1.126,1.126,0,0,1,409,314.625Z",
    transform: "translate(-367.938 -281.531)",
    fill: "#f24462",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_700_",
    d: "M409,398.5a3,3,0,1,0,3,3A3,3,0,0,0,409,398.5Zm0,4.125a1.125,1.125,0,1,1,1.125-1.125A1.126,1.126,0,0,1,409,402.625Z",
    transform: "translate(-367.938 -361.281)",
    fill: "#f24462",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_701_",
    d: "M406.938,268.375a.938.938,0,1,0-.663-.275A.944.944,0,0,0,406.938,268.375Z",
    transform: "translate(-367.938 -241.656)",
    fill: "#f24462",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_702_",
    d: "M406.938,220.375a.938.938,0,1,0-.663-.275A.944.944,0,0,0,406.938,220.375Z",
    transform: "translate(-367.938 -198.156)",
    fill: "#f24462",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_703_",
    d: "M406.938,172.375a.938.938,0,1,0-.663-.275A.944.944,0,0,0,406.938,172.375Z",
    transform: "translate(-367.938 -154.656)",
    fill: "#f24462",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_704_",
    d: "M450.938,266.5a.938.938,0,1,0,.663.275A.944.944,0,0,0,450.938,266.5Z",
    transform: "translate(-407.813 -241.656)",
    fill: "#f24462",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_705_",
    d: "M450.938,218.5a.938.938,0,1,0,.663.275A.944.944,0,0,0,450.938,218.5Z",
    transform: "translate(-407.813 -198.156)",
    fill: "#f24462",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_706_",
    d: "M450.938,170.5a.938.938,0,1,0,.663.275A.944.944,0,0,0,450.938,170.5Z",
    transform: "translate(-407.813 -154.656)",
    fill: "#f24462",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_707_",
    d: "M206.938,172.375a.938.938,0,1,0-.663-.275A.944.944,0,0,0,206.938,172.375Z",
    transform: "translate(-186.688 -154.656)",
    fill: "#f24462",
    stroke: "#000",
    strokeWidth: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg131);
export default __webpack_public_path__ + "static/media/131.ac288f25.svg";
export { ForwardRef as ReactComponent };